(function () {
    "use strict";

    angular.module("app").constant("UPLOAD_MAX_SIZE", 25 * 1024 * 1024);
})();